module.exports = __webpack_public_path__ + "static/media/nicolas.f38c3450.jpeg";